var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNuts(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.0001 2.4V1M3.1001 6.6V9.4C3.10021 10.4898 3.46343 11.5485 4.13237 12.4089C4.80131 13.2692 5.73784 13.8822 6.794 14.1509C7.0824 14.2237 7.3554 14.3553 7.5654 14.5653L8.0001 15L8.4348 14.5653C8.6448 14.3553 8.9178 14.2237 9.2062 14.1509C10.2626 13.8826 11.1994 13.2698 11.8684 12.4093C12.5374 11.5489 12.9005 10.4899 12.9001 9.4V6.6",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 2.39999C5.2 2.39999 2.75 3.79999 2.4 5.19999C2.2299 5.87899 1.7567 6.56639 1 7.29999C1.917 7.24259 2.3804 7.09699 3.1 6.59999C3.478 7.24399 3.7874 7.54919 4.5 7.99999C5.5164 7.54709 5.8678 7.23139 6.25 6.59999C6.6665 7.29649 7.0557 7.59889 8 7.99999C8.917 7.56529 9.3034 7.25939 9.75 6.59999C10.1903 7.28389 10.5634 7.59609 11.5 7.99999C12.3463 7.61639 12.676 7.32309 12.9 6.59999C13.6224 7.24119 14.0781 7.40989 15 7.29999C14.0921 6.57479 13.7694 5.87899 13.6 5.19999C13.25 3.79999 10.8 2.39999 8 2.39999Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNuts);
export default __webpack_public_path__ + "static/media/nuts.e59ba1f15bd0a0ee3eba17acafcc7485.svg";
export { ForwardRef as ReactComponent };